import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import type { WasteItem } from '../data/constants.js';
import { C } from '../data/constants.js';
import { fmt } from '../data/helpers.js';

interface WasteRowProps {
  item: WasteItem;
  index: number;
  maxCount: number;
}

export function WasteRow({ item, index, maxCount }: WasteRowProps): React.ReactElement {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 80px 90px 70px',
        alignItems: 'center',
        padding: '12px 16px',
        borderBottom: `1px solid ${C.cardBorder}`,
        animation: `insights-fadeSlideUp 0.4s ease ${index * 50}ms both`,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span
          style={{
            fontSize: 11,
            color: C.textFaint,
            fontFamily: "'Space Mono', monospace",
            width: 20,
          }}
        >
          {String(index + 1).padStart(2, '0')}
        </span>
        <div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>
            {item.name}
          </div>
          <div
            style={{
              marginTop: 4,
              height: 3,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.04)',
              width: 120,
            }}
          >
            <div
              style={{
                height: '100%',
                borderRadius: 2,
                width: `${(item.count / maxCount) * 100}%`,
                background: `linear-gradient(90deg, ${C.accent}, ${C.accent}40)`,
              }}
            />
          </div>
        </div>
      </div>
      <span
        style={{
          fontSize: 13,
          color: C.textMid,
          fontFamily: "'Space Mono', monospace",
          textAlign: 'right',
        }}
      >
        &times;{item.count}
      </span>
      <span
        style={{
          fontSize: 13,
          color: C.accent,
          fontFamily: "'Space Mono', monospace",
          textAlign: 'right',
          fontWeight: 600,
        }}
      >
        ${fmt(item.cost)}
      </span>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 3 }}>
        {item.trend != null ? (
          <>
            {item.trend <= 0 ? (
              <ArrowDownRight size={12} color={C.accent} />
            ) : (
              <ArrowUpRight size={12} color={C.red} />
            )}
            <span
              style={{ fontSize: 11, fontWeight: 600, color: item.trend <= 0 ? C.accent : C.red }}
            >
              {item.trend}%
            </span>
          </>
        ) : (
          <span style={{ fontSize: 11, color: C.textFaint }}>—</span>
        )}
      </div>
    </div>
  );
}
